/**
 * Resolves the data row under a Recharts chart click. Recharts exposes the
 * hovered column as `activeIndex` (a string in v3, nullable when the click
 * lands outside any bucket); anything that is not a valid row index yields
 * `undefined`.
 */
export function rowFromChartClick<T>(
  state: { activeIndex?: string | number | null },
  data: readonly T[]
): T | undefined {
  const { activeIndex } = state;
  if (activeIndex === null || activeIndex === undefined || activeIndex === '') {
    return undefined;
  }
  const index = Number(activeIndex);
  return Number.isInteger(index) ? data[index] : undefined;
}
